import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Link} from 'react-router-dom'
import {Modal, Button} from 'antd'

import style from './ibModal.sass'

@inject('store') @observer
class IBModal extends Component {
  close = () => {
    this.props.store.ib.closeModal()
  }
  render() {
    const {modal} = this.props.store.ib
    return(
      <Modal
        visible={modal}
        closeable={false}
        styleName='modal'
        footer={[
          <Link key='continue' to='/profile?tab=broker'><Button type='button' styleName='continue'>Go to IB settings</Button></Link>,
          <Button key='cancel' onClick={this.close} styleName='cancel'>Cancel</Button>
        ]}
      >
        <h3>Intraday data is available through Interactive broker&apos;s market data subscription. Go to your profile to activate IB connection.</h3>
      </Modal>
    )
  }
}

export default IBModal
